// Angular
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgChartsModule } from "ng2-charts";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { HttpClientModule } from "@angular/common/http";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// Content
import { BaseComponent } from "@content/base/base.component";
import { ContactComponent } from "@content/contact/contact.component";
import { DataGenerateComponent } from "@content/data-generate/data-generate.component";
import { DevelopmentSummaryComponent } from "@content/developments/development-summary/development-summary.component";
import { DevelopmentsComponent } from "@content/developments/developments.component";
import { ErrorComponent } from "@content/error/error.component";
import { InfoDefinitionComponent } from "@content/info-definition/info-definition.component";
import { IconsComponent } from "@content/icons/icons.component";
import { LandingPageComponent } from "@content/landing-page/landing-page.component";
import { ProjectSummaryComponent } from "@content/projects/project-summary/project-summary.component";
import { ProjectsComponent } from "@content/projects/projects.component";

// Shared
import { ArcgisMapComponent } from "@shared/arcgis-map/arcgis-map.component";
import { FooterComponent } from "@shared/footer/footer.component";
import { HeaderComponent } from "@shared/header/header.component";

// Others
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { DevelopmentProjectDetailsComponent } from "./content/developments/development-project-details/development-project-details.component";
import { DevelopmentProjectBudgetComponent } from "./content/developments/development-project-budget/development-project-budget.component";
import { DevelopmentProjectCardComponent } from "./content/projects/development-project-card/development-project-card.component";
import { DevelopmentProcurementCardComponent } from "./content/developments/development-procurement-card/development-procurement-card.component";
import { ProjectBottomSummaryComponent } from "./content/projects/project-bottom-summary/project-bottom-summary.component";
import { BarChartComponent } from "./content/charts/bar-chart/bar-chart.component";
import { PieChartComponent } from "./content/charts/pie-chart/pie-chart.component";
import { DoughnutChartComponent } from "./content/charts/doughnut-chart/doughnut-chart.component";
import { CarouselComponent } from "./content/carousel/carousel.component";
import { SafeDatePipe } from "./shared/safe-date.pipe";
import { ExpansionPanelGroupComponent } from "@content/expansion-panel/expansion-panel-group/expansion-panel-group.component";
import { ExpansionPanelItemComponent } from "@content/expansion-panel/expansion-panel-item/expansion-panel-item.component";
import { BarChart5YearComponent } from "./content/charts/bar-chart5-year/bar-chart5-year.component";
import { TitleCasewithAvoidWordsPipe } from "./shared/title-casewith-avoid-words.pipe";
import { SimplifyWordsPipe } from "./shared/simplify-words.pipe";
import { LegendsColorComponent } from "./content/charts/legends-color/legends-color.component";
import { DataAutomationComponent } from './content/data-automation/data-automation.component';
import { NotExistDataComponent } from './shared/not-exist-data/not-exist-data.component';
@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    InfoDefinitionComponent,
    ContactComponent,
    FooterComponent,
    HeaderComponent,
    BaseComponent,
    DevelopmentsComponent,
    ProjectsComponent,
    ErrorComponent,
    ProjectSummaryComponent,
    DevelopmentSummaryComponent,
    IconsComponent,
    ArcgisMapComponent,
    DevelopmentProjectDetailsComponent,
    DevelopmentProjectBudgetComponent,
    DevelopmentProjectCardComponent,
    DevelopmentProcurementCardComponent,
    ProjectBottomSummaryComponent,
    DataGenerateComponent,
    BarChartComponent,
    PieChartComponent,
    DoughnutChartComponent,
    CarouselComponent,
    SafeDatePipe,
    ExpansionPanelGroupComponent,
    ExpansionPanelItemComponent,
    BarChart5YearComponent,
    TitleCasewithAvoidWordsPipe,
    SimplifyWordsPipe,
    LegendsColorComponent,
    DataAutomationComponent,
    NotExistDataComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    NgChartsModule,
    PdfViewerModule,
    HttpClientModule,
    CarouselModule.forRoot(),
    BrowserAnimationsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
